






























































import { Component } from 'vue-property-decorator';
import { utils, writeFileXLSX } from 'xlsx';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColumnApi,
} from 'ag-grid-community';

import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

import { fetchMantenedorTipoUbicacion } from './fetchMantenedorTipoUbicacion';
import { getUserID } from './helpers/getUserId';
import ModalViewTipoUbicacion from './ModalViewTipoUbicacion.vue';
import ModalVerHistorico from './ModalVerHistorico.vue';
import moment from 'moment';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
    'app-confirmacion': Confirmation,
    ModalViewTipoUbicacion,
    ModalVerHistorico,
  },
})
export default class MantenedorTipoUbicacionBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.TipoUbicacion;
  loadingService = new LoadingService();
  columnApi: any = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  ordesList: any[] = [];
  data: any = {};
  filtrobusquedagrilla: string = '';
  dialogEliminar: boolean = false;
  showModal: boolean = false;
  anulado: boolean = false;

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        'Tipo de Ubicación': e.tipoubicaname,
        'Fecha De Registro': moment(e.tipoubicafecha_alta).format(
          'YYYY-MM-DD HH:mm'
        ),
        Estado: e.tipoubicabaja,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Tipos_Ubicacion');
    writeFileXLSX(wb, 'Tipos_Ubicacion.xlsx');
    this.$snotify.success('Excel Exportado con éxito', 3000);
  }

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEdit);
    actionsEvent.onVerHistorico(this.handleHistorico);
    actionsEvent.onEliminar(this.handleDelete);
  }

  async recargarGrilla() {
    this.ordesList = await this.getTipoUbicaciones();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.data = {};
  }
  verHistorico: boolean = false;
  tipoubicaname: string = '';
  tipoubicaid: number;
  handleHistorico(params: any) {
    this.tipoubicaid = params.data.tipoubicaid;
    this.tipoubicaname = params.data.tipoubicaname;
    this.verHistorico = true;
  }

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionEditar, this.accionEliminar];

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Tipo de Ubicación',
        field: 'tipoubicaname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 330,
      },
      {
        headerName: 'Fecha De Registro',
        field: 'tipoubicafecha_alta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 330,
        cellRenderer: (param: any) =>
          param.data.tipoubicafecha_alta.substring(0, 19),
      },
      {
        headerName: 'Estado',
        field: 'tipoubicabaja',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 330,
        cellRenderer: (params: any) => {
          return ` <i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
            params.data.tipoubicabaja == 'ACTIVO'
              ? 'rgb(42, 255, 78)'
              : 'rgb(255, 58, 58)'
          }"></i>
                <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${
                  params.data.tipoubicabaja
                }</a>
              `;
        },
      },
    ],
    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getTipoUbicaciones();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleAdd(params: any) {
    this.showViewModal(params, true);
  }

  handleEdit(params: any) {
    this.showViewModal(params);
  }

  showViewModal(
    params: ICellRendererParams,
    addTipoUbicacion: boolean = false
  ) {
    if (addTipoUbicacion) {
      this.data = {};
      this.anulado = false;
    } else {
      this.data = params.data;
      this.anulado = params.data.tipoubicabaja === 'INACTIVO';
    }
    this.showModal = true;
  }

  handleClosedModal() {
    this.showModal = false;
    this.verHistorico = false;
    this.recargarGrilla();
  }

  handleDelete(event: any) {
    this.data = event.data;
    this.dialogEliminar = true;
  }

  handleDeleteTipoUbicacion(event: any) {
    this.dialogEliminar = false;
    if (event) {
      this.deleteTipoUbicacion(this.data);
    }
  }

  async getTipoUbicaciones() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorTipoUbicacion(
      {},
      'api_tipo_ubicacion/get_ubicaciones'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else if (data.data.MENSAJE_RESPUESTA == 'sin registros') {
          return [];
        }
        self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async deleteTipoUbicacion(params: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchMantenedorTipoUbicacion(
      {
        tipoubicaid: Number(params.tipoubicaid),
        tipoubicaname: params.tipoubicaname,
        usuarioid_modifica: getUserID(),
        usuariorut_modifica: localStorage.getItem('clienteDefecto'),
      },
      'api_tipo_ubicacion/delete_ubicacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.ordesList = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(async () => {
        this.loadingService.hideLoading();
        this.recargarGrilla();
      });
  }
}
